
import useWindowSize from "@components/_hooks/useWindowSize";
import DefaultSkeleton from "@components/Components/Reusables/DefaultSkeleton";
import { CreateArray } from "@components/config/helpers";
import Typography from "@mui/material/Typography";

const mobilePaddingSubtitle = {
    paddingLeft: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    paddingRight: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    fontSize: 28
}
const mobilePaddingDescription = {
    paddingLeft: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    paddingRight: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    fontSize: 16,
    paddingBottom: 1
}

const CategoryDescriptions = (props) => {
    const {
        subtitle,
        description,
        loading,
        page
    } = props;

    const { isMobile } = useWindowSize();

    return (
        !loading ? (
            <>
                <Typography
                    sx={mobilePaddingSubtitle}
                    component="h1"
                    // className="f-size_4"
                    color="primary"
                    className="mb-1 fs-22 fs-xs-18 fw-semi-bold"
                >
                    {subtitle}{page > 1 ? ` - Page ${page}` : ''}
                </Typography>
                <Typography
                    sx={mobilePaddingDescription}
                    component="p"
                    className={"fs-16 fs-xs-12"}
                >
                    {description}
                </Typography>
            </>

        ) : (
            <div className="ml-3 pr-3">
                <DefaultSkeleton height={isMobile ? 40 : 65} width={isMobile ? 150 : 200} />
                <CreateArray
                    length={isMobile ? 6 : 3}
                >
                    <DefaultSkeleton height={isMobile ? 20 : 30} />
                </CreateArray>
            </div>
        )
    )
}

export default CategoryDescriptions